import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import BuyVendingMachine from "@/pages/BuyVendingMachine";
import About from "@/pages/About";
import FreeVendingMachines from "@/pages/FreeVendingMachines";
import ThankYou from "@/pages/ThankYou";
import ComingSoon from "@/pages/ComingSoon";
import StartVendingBusiness from "@/pages/StartVendingBusiness";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback BEFORE normal routing (session_id arrives in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/buy-a-vending-machine" element={<BuyVendingMachine region="AU" testId="buy-page-au" />} />
        <Route path="/buy-a-vending-machine-uk" element={<BuyVendingMachine region="UK" testId="buy-page-uk" />} />
        <Route path="/buy-a-vending-machine-usa" element={<BuyVendingMachine region="US" testId="buy-page-usa" />} />
        <Route path="/free-vending-machines-for-businesses" element={<FreeVendingMachines region="AU" testId="free-vending-page-au" />} />
        <Route path="/free-vending-machines-for-businesses-uk" element={<FreeVendingMachines region="UK" testId="free-vending-page-uk" />} />
        <Route path="/free-vending-machines-for-businesses-usa" element={<FreeVendingMachines region="US" testId="free-vending-page-usa" />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/start-your-own-vending-business"
          element={<StartVendingBusiness />}
        />
        <Route
          path="/about-coming-soon"
          element={
            <ComingSoon
              testId="about-coming-soon-page"
              title="About Us"
              description="We're getting this page ready. Meanwhile, learn what we do on the Services page or get in touch."
            />
          }
        />
        <Route
          path="/terms-coming-soon"
          element={
            <ComingSoon
              testId="terms-coming-soon-page"
              title="Terms And Conditions"
              description="Our terms and conditions page is being prepared. Reach out if you need anything in writing right now."
            />
          }
        />
        <Route path="/thank-you" element={<ThankYou />} />
      </Route>
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route
        path="*"
        element={
          <Layout>
            <ComingSoon
              testId="not-found-page"
              title="Page not found"
              description="The page you're looking for doesn't exist."
            />
          </Layout>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster theme="dark" position="bottom-right" />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
